import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { ArrowDownCircle, ArrowUpCircle, CircleSlashedIcon } from 'lucide-react'
import './_appointment-card.scss'
import './_checkin-summary-card.scss'
import { Separator } from 'browser/components/atomic-elements/atoms/separator'
import _ from 'lodash'
import { Formatter } from 'shared-libs/helpers/formatter'

import classNames from 'classnames'

interface ICheckInPassProps {
  appointmentId?: string
  appointmentType: string
  loadType: string
  checkinType: string
  deeplink: string // The URL or data for the QR code
  driverName: string
  phoneNumber: string
  carrierName: string
  trailerId?: string
  assignmentId?: string
  hookTrailerId?: string
  hookAssignment?: string
  isLive?: boolean
}

export class CheckinSummaryCard extends Component<ICheckInPassProps> {
  render() {
    const {
      appointmentId,
      appointmentType,
      deeplink,
      driverName,
      phoneNumber,
      carrierName,
      trailerId,
      loadType,
      assignmentId,
      hookTrailerId,
      hookAssignment,
      isLive,
    } = this.props

    const isOutbound = appointmentType === 'Outbound'
    const IconComponent = appointmentType === 'Outbound' ? ArrowUpCircle : ArrowDownCircle
    const typeClassName = classNames('kiosk-appointment-card__type', {
      outbound: isOutbound,
      inbound: !isOutbound,
    })
    const isConfirmedAppointment = !_.isEmpty(appointmentId)

    const renderDetailItem = (label, value) => {
      return (
        <div>
          <label>{label}</label>
          <span>{value}</span>
        </div>
      )
    }

    const renderQRCodeSection = (value) => {
      return (
        <div className="kiosk-qr-code-section">
          <p className="kiosk-qr-instructions">
            Scan QR code to load this
            <br />
            check-in on mobile device
          </p>
          <div className="kiosk-qr-code-wrapper">
            <QRCode
              value={deeplink}
              renderAs="svg"
              bgColor="#ffffff"
              fgColor="#000000"
              style={{width:"100%", height: "100%"}}
              level="L"
              includeMargin={false}
            />
          </div>
        </div>
      )
    }

    const renderDriverDetails = (name, phone) => {
      return (
        <div className="kiosk-summary-grid-details k-summary-grid-details--dark">
          <div className="kiosk-detail-item">
            <span className="kiosk-detail-label">Driver</span>
            <span className="kiosk-detail-value">{driverName}</span>
          </div>
          <div className="kiosk-detail-item">
            <span className="kiosk-detail-label">Phone Number</span>
            <span className="kiosk-detail-value">{Formatter.formatPhoneNumber(phoneNumber)}</span>
          </div>
        </div>
      )
    }

    const renderShipmentDetails = () => {
      return (
        isConfirmedAppointment && (
          <div className="kiosk-appointment-card__body">
            {renderDetailItem('Appointment Number', appointmentId)}
            {renderDetailItem('Carrier', carrierName)}
            {renderDetailItem('Drop Trailer', trailerId)}
            {renderDetailItem('Drop Assignment', assignmentId ?? 'Pending')}
            {renderDetailItem('Hook Trailer', hookTrailerId ?? 'Pending')}
            {renderDetailItem('Hook Assignment', hookAssignment ?? 'Pending')}
          </div>
        )
      )
    }
    const renderLiveDetails = () => {
      return (
        isConfirmedAppointment && (
          <div className="kiosk-appointment-card__body">
            {renderDetailItem('Appointment Number', appointmentId)}
            {renderDetailItem('Carrier', carrierName)}
            {renderDetailItem('Trailer', trailerId)}
            {renderDetailItem('Door Assignment', assignmentId ?? 'Pending')}
          </div>
        )
      )
    }

    const renderHeader = () => {
      return (
        <header
          className={classNames('kiosk-appointment-card__header', {
            'kiosk-appointment-card__header--unconfirmed': !isConfirmedAppointment,
          })}
        >
          <h3 className="kiosk-appointment-card__name">{appointmentId ?? 'Unconfirmed Shipment'}</h3>

          {isConfirmedAppointment && (
            <span className={typeClassName}>
              <IconComponent size={16} strokeWidth={2.5} />
              {_.join([appointmentType, loadType], ' : ')}
            </span>
          )}
        </header>
      )
    }

    return (
      <div className="kiosk-appointment-card">
        <div className="kiosk-checkin-summary-top">
          {renderHeader()}

          {renderQRCodeSection(deeplink)}
          {renderDriverDetails(driverName, phoneNumber)}
        </div>

        <Separator />

        {isLive ? renderLiveDetails() : renderShipmentDetails()}
      </div>
    )
  }
}

export default CheckinSummaryCard
